import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { AppAuthService, ProductPlansService } from '@prodcard/core'
import ProductPlanTab from './ProductPlanTab.vue'
import ProdductSupplyListTab from './ProductSupplyListTab.vue'
import { ref, nextTick } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductPlanPage',
  props: {
    productPlansService: {},
    authService: {}
  },
  setup(__props: any) {



const updateRequired = ref(false)
const tab = ref('prodplan')
const supplyList = ref()
const onListSelect = async () => {
  if (updateRequired.value) {
    updateRequired.value = false
    await nextTick()
    supplyList.value.update()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "auto" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (tab.value = 'prodplan')),
              variant: tab.value === 'prodplan' ? 'flat' : 'tonal',
              size: "large",
              ripple: false
            }, {
              default: _withCtx(() => [
                _createTextVNode("Прод. план")
              ]),
              _: 1
            }, 8, ["variant"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "auto" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (tab.value = 'history')),
              variant: tab.value === 'history' ? 'flat' : 'tonal',
              size: "large",
              ripple: false
            }, {
              default: _withCtx(() => [
                _createTextVNode("История действий")
              ]),
              _: 1
            }, 8, ["variant"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_window, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tab).value = $event)),
          class: "pt-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window_item, { value: "prodplan" }, {
              default: _withCtx(() => [
                _createVNode(ProductPlanTab, {
                  "auth-service": _ctx.authService,
                  "product-plans-service": _ctx.productPlansService,
                  onNewSupply: _cache[2] || (_cache[2] = ($event: any) => (updateRequired.value = true))
                }, null, 8, ["auth-service", "product-plans-service"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, {
              value: "history",
              "onGroup:selected": onListSelect
            }, {
              default: _withCtx(() => [
                _createVNode(ProdductSupplyListTab, {
                  "product-plans-service": _ctx.productPlansService,
                  ref_key: "supplyList",
                  ref: supplyList
                }, null, 8, ["product-plans-service"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}
}

})